import React from 'react';

function Nopage (){
    return(
        <div>No Page found. </div>
    )
};
export default Nopage;